var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('froala',{attrs:{"tag":'textarea',"config":_vm.config},model:{value:(_vm.modelContent),callback:function ($$v) {_vm.modelContent=$$v},expression:"modelContent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }